import { Injectable, EventEmitter, Inject, isDevMode } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { TokenHttp } from '../services/tokenhttp.service';
import { BaseRepository } from './base.repository';
import { IDriver } from '../interfaces/IDriver';
;

@Injectable()
export class CarrierDriverRepository extends BaseRepository {

  constructor(tokenHttp: TokenHttp) {
    super(tokenHttp);
  }

  public getAll(): Observable<IDriver[]> {
    return this.mapGet("carrier/drivers/");
  }

  public getById(id: number): Observable<IDriver> {
    return this.mapGet("carrier/drivers/" + id);
  }

  public create(driver: IDriver): Observable<IDriver> {
    return this.mapPost("carrier/drivers/", driver);
  }

  public update(driver: IDriver): Observable<IDriver> {
    return this.mapPut("carrier/drivers/" + driver.id, driver);
  }

}
